import React from 'react'
import { useTranslation } from 'react-i18next'

import LabelsSection from '../../reusableFields/LabelsSection'

const AdvancedSettings = ({ formik }) => {
  const { t } = useTranslation()

  return (
    <>
      <LabelsSection
        formik={formik}
        description={t(
          'Apply a label if ads in this campaign should not be shown along side other campaigns with the same label.'
        )}
      />

      {/*todo PBR-1310 Uncomment when find out how to format payload of custom fields to BE*/}
      {/*<section className={drawerFormClasses.section}>*/}
      {/*  <h4 className={drawerFormClasses.sectionTitle}>{t('Custom Fields')}</h4>*/}
      {/*  <p>{t('Apply a custom field to capture custom information in Google Ad Manager.')}</p>*/}
      {/*  <FieldLabelWrapper label={t('Custom Field')}>*/}
      {/*    <CustomFieldsSelect formik={formik} />*/}
      {/*  </FieldLabelWrapper>*/}
      {/*</section>*/}
    </>
  )
}

export default AdvancedSettings
